/**
 * To be able to stub out document functions in tests, these are being wrapped in functions
 * If more document functions are used that need to be mocked this is where they should be added
 */

export const documentLinks = () => document.links;
